import { render, staticRenderFns } from "./CandidateAnswersRateModal.vue?vue&type=template&id=66d64940&"
import script from "./CandidateAnswersRateModal.vue?vue&type=script&lang=js&"
export * from "./CandidateAnswersRateModal.vue?vue&type=script&lang=js&"
import style0 from "./CandidateAnswersRateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports